import { render, staticRenderFns } from "./createProject.vue?vue&type=template&id=e5dfd77a&scoped=true&"
import script from "./createProject.vue?vue&type=script&lang=js&"
export * from "./createProject.vue?vue&type=script&lang=js&"
import style0 from "./createProject.vue?vue&type=style&index=0&id=e5dfd77a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5dfd77a",
  null
  
)

export default component.exports